import React from 'react';
import classNames from 'classnames';
import './Card.css';

const Card = ({
    children,
    className,
    padding = 'default',
    shadow = 'default',
    onClick,
    hover = false,
    ...props
}) => {
    const cardClasses = classNames(
        'card',
        `card-padding-${padding}`,
        `card-shadow-${shadow}`,
        {
            'card-clickable': onClick || hover,
        },
        className
    );

    return (
        <div className={cardClasses} onClick={onClick} {...props}>
            {children}
        </div>
    );
};

export default Card;
